import { filterContentItems, sanitizeDoubleQuotes } from "../utils";
import {
  isBase64Valid,
  getLang,
  convertDateToTimestamp,
  convertTimestampToDate,
  setIfUrlExist,
} from "../../../js/utils/functions";
import { ContentItemMapper } from "./ContentItemMapper";
import { AreasMapper } from "./AreasMapper";
import { SoftwaresMapper } from "./SoftwaresMapper";

export const ProjectMapper = {
  dehydrate: project => {
    const {
      id,
      name,
      contentItems,
      courseId,
      cover,
      coverFileName,
      isPublic,
      madeAt,
      url,
      client,
      clientUrl,
      agency,
      agencyUrl,
      areaIds,
      softwareIds,
      dayPublished,
      monthPublished,
      yearPublished,
      sharedVisibility,
      reCaptchaToken,
    } = project;
    const data = {
      id: (typeof id === "string" && id) || null,
      name: (typeof name === "string" && sanitizeDoubleQuotes(name, { action: "escape" })) || "",
      lang: getLang,
      courseId:
        ((typeof courseId === "string" || typeof courseId === "number") &&
          courseId !== "null" &&
          courseId) ||
        null,
      coverFileName:
        (typeof coverFileName === "string" &&
          sanitizeDoubleQuotes(coverFileName, { action: "remove" })) ||
        "",
      isPublic: typeof isPublic === "boolean" && isPublic,
      madeAt:
        (dayPublished &&
          monthPublished &&
          yearPublished &&
          convertDateToTimestamp(dayPublished, monthPublished, yearPublished)) ||
        madeAt ||
        null,
      reCaptchaToken: (typeof reCaptchaToken === "string" && reCaptchaToken) || "",
      client:
        (typeof client === "string" && sanitizeDoubleQuotes(client, { action: "escape" })) || "",
      clientUrl:
        (typeof clientUrl === "string" && sanitizeDoubleQuotes(clientUrl, { action: "remove" })) ||
        "",
      agency:
        (typeof agency === "string" && sanitizeDoubleQuotes(agency, { action: "escape" })) || "",
      agencyUrl:
        (typeof agencyUrl === "string" && sanitizeDoubleQuotes(agencyUrl, { action: "remove" })) ||
        "",
      url: (typeof url === "string" && sanitizeDoubleQuotes(url, { action: "remove" })) || "",
      areaIds: (typeof areaIds === "object" && AreasMapper.dehydrate(areaIds)) || [],
      softwareIds: (typeof softwareIds === "object" && softwareIds) || [],

      contentItems:
        (typeof contentItems === "object" &&
          contentItems.map(contentItem => ContentItemMapper.dehydrate(contentItem))) ||
        [],
    };

    if (typeof sharedVisibility === "boolean") {
      data.sharedVisibility = sharedVisibility;
    }

    if (!cover) {
      data.cover = "";
    }

    if (typeof cover === "string" && isBase64Valid(cover)) {
      data.cover = cover;
    }

    return data;
  },
  hydrate: project => {
    const {
      id,
      name,
      lang,
      contentItems,
      course,
      cover,
      coverFileName,
      isPublic,
      madeAt,
      sharedVisibility,
      url,
      client,
      clientUrl,
      agency,
      agencyUrl,
      areas,
      softwares,
      errors,
      user,
      railsRoutes,
    } = project;
    let publishedDate = {};

    if (typeof madeAt === "number") {
      publishedDate = convertTimestampToDate(madeAt);
    }

    const data = {
      id: (typeof id === "string" && id) || "",
      name: (typeof name === "string" && name !== "undefined" && name) || "",
      lang: typeof lang === "string" && lang,
      course: (typeof course === "object" && course) || null,
      cover: (typeof cover === "object" && setIfUrlExist(cover?.url[0]) && cover?.url[0]) || null,
      coverFileName: typeof coverFileName === "string" && coverFileName,
      isPublic: typeof isPublic === "boolean" && isPublic,
      madeAt: (typeof madeAt === "number" && madeAt) || null,
      dayPublished: publishedDate?.day,
      monthPublished: publishedDate?.month,
      yearPublished: publishedDate?.year,
      url: (typeof url === "string" && url !== "null" && url) || "",
      sharedVisibility: typeof sharedVisibility === "boolean" ? sharedVisibility : true,
      client: (typeof client === "string" && client !== "null" && client) || "",
      clientUrl: (typeof clientUrl === "string" && clientUrl !== "null" && clientUrl) || "",
      agency: (typeof agency === "string" && agency !== "null" && agency) || "",
      agencyUrl: (typeof agencyUrl === "string" && agencyUrl !== "null" && agencyUrl) || "",
      areaIdsSaved:
        (typeof areas === "object" && areas.map(element => AreasMapper.hydrateSingle(element))) ||
        [],
      areaIds:
        (typeof areas === "object" && areas.map(element => AreasMapper.hydrateId(element))) || [],
      softwareIdsSaved:
        (typeof softwares === "object" &&
          softwares.map(element => SoftwaresMapper.hydrateSingle(element))) ||
        [],
      softwareIds:
        (typeof softwares === "object" &&
          softwares.map(element => SoftwaresMapper.hydrateId(element))) ||
        [],
      contentItems: filterContentItems(contentItems),
      errors: typeof errors === "object" && errors.map(error => error),
      portfolioUserUrl:
        (typeof user?.railsRoutes?.portfolioUserUrl === "string" &&
          user?.railsRoutes?.portfolioUserUrl) ||
        "",
      projectUrl: (typeof railsRoutes?.projectUrl === "string" && railsRoutes?.projectUrl) || "",
    };

    return data;
  },
};
